import useDataFetcher, { UseDataFetcherReturn } from 'Hooks/Http/useDataFetcher';
import Project from 'Models/Project';
import getProjectsRequest from 'Utils/Http/Requests/Projects/GetProjectsRequest';

const useFetchProjects = (): UseDataFetcherReturn<Project[]> => useDataFetcher(getProjectsRequest);

export default useFetchProjects;
